"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StarRatingComponent = void 0;
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _times = _interopRequireDefault(require("lodash/times"));
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _messages = _interopRequireDefault(require("./messages"));
var _styles = require("./styles");
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _StarRatingComponent;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var StarRatingComponent = exports.StarRatingComponent = (0, _reactIntl.injectIntl)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_StarRatingComponent = /*#__PURE__*/function (_Component) {
  function StarRatingComponent(props) {
    var _this;
    _classCallCheck(this, StarRatingComponent);
    _this = _callSuper(this, StarRatingComponent, [props]);
    _initializerDefineProperty(_this, "hoveredRating", _descriptor, _this);
    _initializerDefineProperty(_this, "isHovered", _descriptor2, _this);
    _initializerDefineProperty(_this, "rating", _descriptor3, _this);
    _initializerDefineProperty(_this, "setHoveredRating", _descriptor4, _this);
    _initializerDefineProperty(_this, "setIsHovered", _descriptor5, _this);
    _initializerDefineProperty(_this, "setRating", _descriptor6, _this);
    _defineProperty(_this, "handleMouseEnter", function () {
      _this.setIsHovered(true);
    });
    _defineProperty(_this, "handleMouseLeave", function () {
      _this.setIsHovered(false);
    });
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(StarRatingComponent, _Component);
  return _createClass(StarRatingComponent, [{
    key: "visibleRating",
    get: function get() {
      return this.isHovered ? this.hoveredRating : this.rating;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        intl = _this$props.intl,
        numOfRating = _this$props.numOfRating;
      var formatMessage = intl.formatMessage;
      return /*#__PURE__*/_react["default"].createElement(_styles.StarRating, {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, (0, _times["default"])(numOfRating).map(function (index) {
        return /*#__PURE__*/_react["default"].createElement(_styles.StarClickArea, {
          key: index,
          "aria-label": formatMessage(_messages["default"].campaign_stars, {
            numberOfStars: index + 1
          }),
          "data-cy": "star",
          onClick: function onClick() {
            return _this2.setRating(index + 1);
          },
          onMouseEnter: function onMouseEnter() {
            return _this2.setHoveredRating(index + 1);
          },
          role: "button"
        }, /*#__PURE__*/_react["default"].createElement(_styles.StyledIcon, {
          name: _this2.visibleRating > index ? 'star' : 'star-border',
          size: 40
        }));
      }));
    }
  }]);
}(_react.Component), _defineProperty(_StarRatingComponent, "propTypes", {
  numOfRating: _propTypes["default"].number.isRequired,
  onSelect: _propTypes["default"].func
}), _StarRatingComponent), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "hoveredRating", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "isHovered", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "rating", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "visibleRating", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleRating"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "setHoveredRating", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (rating) {
      _this3.hoveredRating = rating;
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "setIsHovered", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (isHovered) {
      _this4.isHovered = isHovered;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "setRating", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (rating) {
      _this5.rating = rating;
      (0, _invoke["default"])(_this5.props, 'onSelect', _this5.rating);
    };
  }
})), _class2)) || _class) || _class;
var _default = exports["default"] = StarRatingComponent;
//# sourceMappingURL=index.js.map